import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { MIN_STEPS_FOR_SEARCH } from '../constants/searchSteps';

/**
 * Search and reset buttons component with dynamic state based on completed steps
 * @param {Object} props - Component props
 * @param {number} props.completedStepsCount - Number of completed steps
 * @param {boolean} props.areAllRequiredStepsValid - Whether all required steps are valid
 * @param {Function} props.onSearch - Search handler function
 * @param {Function} props.onReset - Reset handler function
 * @returns {JSX.Element} SearchButton component
 */
const SearchButton = ({ completedStepsCount, areAllRequiredStepsValid, onSearch, onReset }) => {
  const { t } = useTranslation('treatment-search');

  const isSearchEnabled = areAllRequiredStepsValid && completedStepsCount >= MIN_STEPS_FOR_SEARCH;

  const hasSelections = completedStepsCount > 0;

  return (
    <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 py-6 sm:py-8 px-4">
      <Button
        size="large"
        onClick={onReset}
        disabled={!hasSelections}
        className="w-full sm:w-auto h-11 sm:h-12 px-6 sm:px-8 text-sm sm:text-base font-medium order-2 sm:order-1"
      >
        {t('actions.reset', 'Réinitialiser')}
      </Button>

      <Button
        type="primary"
        size="large"
        onClick={onSearch}
        disabled={!isSearchEnabled}
        style={{
          backgroundColor: isSearchEnabled ? '#A0D911' : undefined,
          borderColor: isSearchEnabled ? '#7CB305' : undefined,
        }}
        className="w-full sm:w-auto h-11 sm:h-12 px-6 sm:px-8 text-sm sm:text-base font-medium order-1 sm:order-2"
      >
        {t('actions.search')}
      </Button>
    </div>
  );
};

export default SearchButton;
